export * from 'fumadocs-ui/internal/icons';
